<template>
  <a-card :bordered="false">
    <div class="banner_container gggl">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper postionRelative">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="目录课程名称">
                <a-input
                  placeholder="请输入目录课程名称"
                  v-model="queryParam.articleTitle"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12">
              <a-form-item label="状态">
                <j-dict-select-tag
                  v-model="queryParam.articleStatus"
                  placeholder="请选择状态"
                  dictCode="course_status"
                  value="1"
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8" style="float: left; overflow: hidden">
              <span
                style="text-align: right"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-button class="goBackBtn" type="primary" @click="closeCurrent()"
          >返回</a-button
        >
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button
          @click="handleAdd({ articleType: articleType, parentId: parentId })"
          type="primary"
          icon="plus"
          >新增</a-button
        >
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchReview(selectedRowKeys)"
              ><a-icon type="check" />批量审核</a-menu-item
            >
            <a-menu-item key="2" @click="batchPublish(selectedRowKeys)"
              ><a-icon type="snippets" />批量发布</a-menu-item
            >
            <a-menu-item key="3" @click="batchPush(selectedRowKeys)"
              ><a-icon type="appstore" />批量推送</a-menu-item
            >
          </a-menu>
          <a-button> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <!-- 清空 -->
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <!-- 表格 -->
      <a-table
        ref="tableSelect"
        :columns="columns"
        rowKey="id"
        :scroll="{ x: 1240 }"
        bordered
        :data-source="dataSource"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :loading="loading"
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="handleEdit(record, record.id)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.status == 1">
                <a-popconfirm
                  title="确定提交审核吗?"
                  @confirm="() => handleSubmit(record)"
                >
                  <a>提交</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 2">
                <a href="javascript:;" @click="handleReview(record)">审核</a>
              </a-menu-item>

              <a-menu-item v-if="record.status == 3">
                <a-popconfirm
                  title="确定发布吗?"
                  @confirm="() => handlePublish(record)"
                >
                  <a>发布</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 4">
                <a-popconfirm
                  title="确定推送吗?"
                  @confirm="() => handlePush(record)"
                >
                  <a>推送</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 4">
                <a-popconfirm
                  title="确定下架吗?"
                  @confirm="() => handleOffShelf(record)"
                >
                  <a>下架</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 5">
                <a-popconfirm
                  title="确定提交审核吗?"
                  @confirm="() => handleSubmit(record)"
                >
                  <a>提交审核</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item>
                <a href="javascript:;" @click="onDelete(record.id)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>

      <notice-manage-modal
        ref="modalForm"
        @ok="modalFormOk"
      ></notice-manage-modal>

      <!--  文章审核-->
      <a-modal
        title="审核"
        :visible="showReview"
        :width="800"
        @cancel="showReview = false"
        @ok="handalExamine"
      >
        <a-radio-group v-model="examineFlg" @change="examineFlgChange">
          <a-radio :value="1">审核通过</a-radio>
          <a-radio :value="2">审核驳回</a-radio>
        </a-radio-group>

        <a-textarea
          style="margin-top: 20px"
          placeholder="请输入理由"
          v-model="reason"
          :max-length="100"
          :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-modal>

      <!--  文章审核-->
      <a-modal
        title="批量审核"
        :visible="batchReviewModel.showReview"
        :width="800"
        @cancel="batchReviewModel.showReview = false"
        @ok="batchHandalExamine"
      >
        <a-radio-group
          v-model="batchReviewModel.examineFlg"
          @change="batchExamineFlgChange"
        >
          <a-radio :value="1">审核通过</a-radio>
          <a-radio :value="2">审核驳回</a-radio>
        </a-radio-group>

        <a-textarea
          style="margin-top: 20px"
          placeholder="请输入批量审核理由"
          v-model="batchReviewModel.reason"
          :max-length="100"
          :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-modal>
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import noticeManageModal from '../articleManage/modules/noticeManageModal';
import { postTag, postAction, downFile } from '@/api/manage';
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil';
const columns = [
  {
    align: 'center',
    title: '目录课程名称',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
  },
  {
    align: 'center',
    title: '学习人数',
    dataIndex: 'totalStudyNumber',
    customRender: (text) => {
      return text;
    },
    ellipsis: true,
  },
  {
    align: 'center',
    title: '点赞数',
    dataIndex: 'totalLikes',
    customRender: (text) => {
      return text;
    },
    ellipsis: true,
  },
  {
    align: 'center',
    title: '发布状态',
    dataIndex: 'status',
    customRender: function (text) {
      return filterDictTextByCache('course_status', text);
    },
  },
  {
    align: 'center',
    title: '审核意见',
    dataIndex: 'refuseReason',
    customRender: (text) => {
      return !text || text == '' ? '--' : text;
    },
    ellipsis: true,
  },
  {
    align: 'center',
    title: '推送状态',
    dataIndex: 'propeStatus',
    customRender: function (text) {
      return filterDictTextByCache('course_put_status', text);
    },
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    fixed: 'right',
    scopedSlots: {
      customRender: 'operation',
    },
  },
];

export default {
  inject: ['closeCurrent'],
  components: {
    noticeManageModal,
  },
  data() {
    return {
      //--------列表页重复代码 start-------------
      searchObj: {
        id: '',
        status: '',
        memberName: '',
        mobileNumber: '',
        unionid: '',
        goodsName: '',
        paymentType: '',
      },
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* table选中keys*/
      selectedRowKeys: [],
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      //--------列表页重复代码 end-------------
      columns,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      // 目录管理新增
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/content/article/courseList', //查询列表
        delete:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/delDirctory', //删除
        putStatus:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/putStatus', //提交，审核，发布，下架
        pushStatus:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/pushStatus', //推送
        batchReview:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/batchReview', //批量审核
        batchPublish:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/batchPublish', //批量发布
        batchPush:
          process.env.VUE_APP_CMS_CONTENT + '/content/article/batchPush', //批量推送
      },
      parentId: this.$route.query.id, //课程ID
      articleType: 2,
      showReview: false, //审核弹窗
      examineFlg: 1, //1-审核通过 2-审核拒绝
      reason: '', //审核拒绝理由
      currentExamine: {}, //当前要审核的数据
      queryParam: {
        articleTitle: '', //查询参数标题
        articleStatus: undefined, //查询参数状态
      },
      batchReviewModel: {
        showReview: false, //审核弹窗
        examineFlg: 1, //1-审核通过 2-审核拒绝
        reason: '', //审核拒绝理由
        currentExamine: [], //当前要审核的数据
      },
      visible: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    onClose() {
      this.visible = false;
    },
    batchPush(ids) {
      //批量推送
      postAction(this.url.batchPush, {
        ids: ids.join(','),
      }).then((res) => {
        if (res.success) {
          this.loadData(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    batchPublish(ids) {
      //批量发布
      postAction(this.url.batchPublish, {
        ids: ids.join(','),
      }).then((res) => {
        if (res.success) {
          this.loadData(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    batchReview(ids) {
      //批量审核
      this.batchReviewModel.showReview = true;
      this.batchReviewModel.currentExamine = ids;
    },
    handlePush(record) {
      //课程管理-推送
      let that = this;
      that.loading = true;
      postAction(that.url.pushStatus, {
        id: record.id,
        recordStatus: record.status,
      })
        .then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
          } else {
            that.$message.error(res.message);
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    handleOffShelf(record) {
      //课程管理-下架
      let that = this;
      that.loading = true;
      postAction(that.url.putStatus, {
        id: record.id,
        recordStatus: record.status,
      })
        .then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
          } else {
            that.$message.error(res.message);
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    handlePublish(record) {
      //课程管理-发布
      let that = this;
      that.loading = true;
      postAction(that.url.putStatus, {
        id: record.id,
        recordStatus: record.status,
      })
        .then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
          } else {
            that.$message.error(res.message);
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    handleSubmit(record) {
      //课程管理 -提交
      let that = this;
      that.loading = true;
      postAction(that.url.putStatus, {
        id: record.id,
        recordStatus: record.status,
      })
        .then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
          } else {
            that.$message.error(res.message);
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    handleReview(record) {
      //课程管理-审核
      this.showReview = true;
      this.currentExamine = record;
    },
    onDelete(id) {
      // 课程管理-删除
      let that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    examineFlgChange(e) {
      //审核通过和不通过选择
      this.examineFlg = e.target.value;
    },
    handalExamine() {
      //审核结果提交
      if (this.examineFlg == '') {
        this.$message.warning('请选你要审核的状态');
      }
      postAction(this.url.putStatus, {
        id: this.currentExamine.id,
        recordStatus: this.currentExamine.status,
        reviewStatus: this.examineFlg,
        reason: this.reason == '' ? null : this.reason,
      }).then((res) => {
        if (res.success) {
          this.showReview = false;
          this.loadData(1);
          this.reason = '';
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    batchExamineFlgChange(e) {
      //审核通过和不通过选择
      this.batchReviewModel.examineFlg = e.target.value;
    },
    batchHandalExamine() {
      //审核结果提交
      if (this.batchReviewModel.examineFlg == '') {
        this.$message.warning('请选你要审核的状态');
      }
      postAction(this.url.batchReview, {
        ids: this.batchReviewModel.currentExamine.join(','),
        reviewStatus: this.batchReviewModel.examineFlg,
        reason: this.batchReviewModel.reason,
      }).then((res) => {
        if (res.success) {
          this.batchReviewModel.showReview = false;
          this.loadData(1);
          this.batchReviewModel.reason = '';
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipagination = pagination;
      this.loadData({
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      let params = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        title: this.queryParam.articleTitle,
        status: this.queryParam.articleStatus || 0,
        articleType: 2, //课程类型
        parentId: this.parentId,
      };
      console.log('321321', params);
      this.loading = true;
      postTag(this.url.list, params).then((res) => {
        this.loading = false;
        this.dataSource =
          res.result && res.result.records ? res.result.records : [];
        this.dataSource.forEach((item) => {
          item.statusFlg = item.status == 0 ? false : true;
        });
        this.ipagination.total = res.result.total;
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
    searchQuery() {
      this.loadData(1);
    },
    //重置
    searchReset() {
      this.queryParam.articleTitle = '';
      this.queryParam.articleStatus = undefined;
      this.loadData();
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.name);
      if (this.name == 'courseManageModal') {
        let courseList = selectedRowKeys;
        this.form.setFieldsValue({
          courseList,
        });
      }
    },
    handleAdd: function (course) {
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }

      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
  },
};
</script>

<style scoped lang="less">
.postionRelative {
  position: relative;
  .goBackBtn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.banner_container {
  background: #fff;
  .table-operator {
    margin-bottom: 8px;
  }
  .table-operator {
    .ant-btn {
      margin: 0 8px 8px 0;
    }
  }
  .lm {
    z-index: 999;
  }

  .banner_title {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    font-size: 22px;
    color: #333;
    margin-bottom: 20px;
  }

  .banner_btns {
    margin-bottom: 20px;

    .ant-btn {
      margin-right: 10px;
    }
  }

  .ant-table-wrapper {
    margin-bottom: 30px;
  }

  .bannerImg {
    display: flex;

    .img_item {
      width: 250px;
      height: 170px;

      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
<style lang="less">
.gggl {
  .ant-select-open .ant-select-selection,
  .lm .ant-select-selection--multiple {
    overflow-y: scroll;
  }
}
.edit-upload {
  margin-left: 136px;
  margin-bottom: 23px;

  .pdf {
    color: #999;
    margin-left: 10px;
  }
}
</style>
